import {
  BANNER_VARIANT_CONFIG,
  DEFAULT_VARIANT,
  POPUP_VARIANT_CONFIG,
  VariantStyles
} from './constants/variantConfig';
import { ComponentType } from './types';

export interface ComponentRegistryEntry {
  variantConfig: Record<string, VariantStyles>;
  defaultVariant: string;
}

export const COMPONENT_REGISTRY: Record<string, ComponentRegistryEntry> = {
  [ComponentType.BANNER]: {
    variantConfig: BANNER_VARIANT_CONFIG,
    defaultVariant: DEFAULT_VARIANT
  },
  [ComponentType.POPUP]: {
    variantConfig: POPUP_VARIANT_CONFIG,
    defaultVariant: DEFAULT_VARIANT
  }
};
